export default {
  tourUi: {
    loading: 'Cargando paseo...',
    status: {
      unavailable: 'No disponible',
    },
    backToTours: 'Volver a los paseos',
    seo: {
      keywordPrefix: 'paseo Paraty',
      breadcrumbHome: 'Inicio',
      breadcrumbTours: 'Paseos',
      touristTypes: ['Familia', 'Pareja', 'Aventura'],
    },
    gallery: {
      expand: 'Ampliar imagen',
      close: 'Cerrar',
      photoAlt: '{{title}} - foto {{n}}',
      thumbAlt: '{{title}} - miniatura {{n}}',
    },
    booking: {
      pixDeposit: 'Seña vía Pix',
      remaining: 'Saldo a pagar el día del paseo',
      depositNote: 'Seña del {{rate}}% del total, con un mínimo de R$ 20,00.',
      depositFixedPerson: 'Seña de {{amount}} por persona.',
      depositFixedBooking: 'Seña fija de {{amount}} por reserva.',
      depositMixed: 'La seña suma lo de cada paseo (porcentaje o valor fijo), con un mínimo de R$ 20,00.',
      fullNote: 'El valor total del paseo se paga ahora para asegurar la reserva.',
      minDate: 'Elige una fecha a partir del {{date}}.',
      seatsLeft_one: 'Solo queda {{count}} lugar disponible para este paseo.',
      seatsLeft_other: 'Solo quedan {{count}} lugares disponibles para este paseo.',
      decrease: 'Disminuir {{label}}',
      increase: 'Aumentar {{label}}',
    },
  },
};
